import React, { useContext } from 'react';
import { TrainerContext } from '../../context/TrainerContext';
import { ChatProvider } from '../../context/ChatContext';
import TrainerLayout from '../trainer/TrainerLayout';
import ChatPage from './ChatPage';

const TrainerChatPage = () => {
    const { trainer } = useContext(TrainerContext);

    if (!trainer) return null;

    return (
        <TrainerLayout noPadding fullWidth>
            <ChatProvider userId={trainer.id}>
                <ChatPage
                    userId={trainer.id}
                    userRole="ROLE_TRAINER"
                    schoolId={trainer.schoolId}
                />
            </ChatProvider>
        </TrainerLayout>
    );
};

export default TrainerChatPage;
